import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row, ListGroup, ListGroupItem} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ModalManager from '../../../../components/modal/ModalManager';
import {i18nizeDate} from '../../../../helpers/Utils';
import Rbac from '../../../../components/Rbac';
import {store} from '../../../../AppRenderer';
import {withTranslation} from 'react-i18next';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      pages: -1,
      loading: false,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/group-message',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            type: 'SMS',
          }
        }
      );
      this.setState({
        messages: data.messages,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/notifications/groupSMS/create');
  };

  renderDestinations = data => {
    return (
      <div style={{overflowY: 'scroll', maxHeight: 300}}>
        <ListGroup className='px-0'>
          {data.map(item => <ListGroupItem key={item}>{item}</ListGroupItem>)}
        </ListGroup>
      </div>
    );
  };

  showDestinations = destinations => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Destination Mobile Numbers'),
      body: this.renderDestinations(destinations),
      scrollable: true,
      buttons: [
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = () => {
    const {t} = this.props;
    const {groupMessageSettings} = store.getState().app;
    return (
      [
        {
          Header: t('Message'),
          accessor: 'message',
        },
        {
          Header: t('Sent to'),
          accessor: 'metaInfo',
          Cell: props => {
            const metaInfo = props.value;
            if (metaInfo && metaInfo.destinationCategories && metaInfo.destinationCategories.length) {
              return (
                <span>
                  {metaInfo.destinationCategories.map(item => {
                    return (
                      groupMessageSettings['SMS'].destinationCategories[item].localeName
                    );
                  }).join(', ')}
                </span>
              );
            }
            return null;
          }
        },
        {
          Header: t('Destination Mobile Numbers'),
          accessor: 'destinations',
          width: 160,
          Cell: props => {
            if (props.value && props.value.length) {
              return (
                <span className='text-success cursor-pointer' onClick={() => {this.showDestinations(props.value);}}>
                  <i className='text-large icon-Business-Mens'/>
                  <span className='mx-1'>{t('View')}</span>
                </span>
              );
            }
            return null;
          },
        },
        {
          Header: t('SMS service'),
          accessor: 'metaInfo',
          width: 140,
          Cell: props => {
            const metaInfo = props.value;
            if (metaInfo && metaInfo.destinationCategories && metaInfo.service) {
              return (
                <span>{metaInfo.service}</span>
              );
            }
            return null;
          }
        },
        {
          Header: t('Submit Date'),
          accessor: 'createdAt',
          width: 160,
          Cell: props => <span>{i18nizeDate(props.value)}</span>,
        },
      ]
    );
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center">
                  <Rbac permission='create_group-message'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Send New Message')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.messages}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns()}
                  defaultPageSize={10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
